// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/depth-perception-cues.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/depth-perception-cues/depth-perception-cues.js';

mount([g0]);
